<mat-toolbar class="footer mat-elevation-z8">
  <div class="footer-content">
    <a href=""
      ><img class="logo" src="assets/img/channels-616_marca_colombia.png" width="40px" alt="FOOTER"
    /></a>

    <a href=""><img class="logo" src="assets/img/header_govco.png" width="130px" alt="FOOTER" /></a>
  </div>
</mat-toolbar>
